import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.less'],
})
export class ForgotPasswordComponent implements OnInit {
  isLinkExpired: boolean = false;
  constructor(private route: ActivatedRoute) {
    if (this.route.snapshot.queryParams['link-expired'] === 'true') {
      this.isLinkExpired = true;
    }
  }

  ngOnInit(): void {}
}
